import { useCachedFetch } from './index';
import apiRoutes from '../../../config/api/routes';
import { IGroupStudent } from 'src/config/api/models/User';

export const useStudentsByGroup = (groupId: string, enabled = true) => {
  return useCachedFetch<{data: IGroupStudent[]}>(
    ['getStudentsByGroup', groupId],
    apiRoutes.groupStudents(groupId),
    {
      options: {
        enabled,
      },
    }
  );
};
